import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mockData';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  return (
    <section className="bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-[#DC2626] to-[#B91C1C] mb-6 shadow-xl">
            <HelpCircle className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Häufig gestellte <span className="text-[#DC2626]">Fragen</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Antworten auf die wichtigsten Fragen rund um Altbausanierung
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="bg-white rounded-xl shadow-md border border-gray-100 px-6 hover:shadow-lg transition-all duration-300"
              >
                <AccordionTrigger className="text-left hover:text-[#DC2626] transition-colors py-6">
                  <span className="text-lg font-semibold pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6 pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
